import { Injectable } from '@angular/core';
import { UrlService } from '@shared/services/url/url.service';
import { HttpService, ResponseType } from '@shared/services/http/http.service';
import { throwError, catchError, Observable } from 'rxjs';

export interface CreateErrorDTO {
  errorText: string;
  responsibleArea: string;
  troubleshooting: string;
}

export interface UpdateErrorDTO extends CreateErrorDTO {
  id: string;
}

@Injectable()
export class ErrorReportService {
  constructor(
    private _urlService: UrlService,
    private _httpService: HttpService
  ) {}

  getErrorList(page: number, pageSize: number, filter: string): Observable<any[]> {
    const url = this._urlService.getUrl('API_URL_TVF_LOGS.getErros', {
      page,
      pageSize,
      filter,
    });
    return this._httpService.get(url, null).pipe(catchError((err) => throwError(() => err)));
  }

  tradeReprocess(tradeId: string): Observable<any[]> {
    const payload = { tradeIds: [tradeId] };
    const url = this._urlService.getUrl('COLLECT_TVF.tradeReprocess', { payload });

    return this._httpService.post(url, payload).pipe(catchError(throwError));
  }
  batchReprocess(tradeIdList: string[]): Observable<any[]> {
    const payload = { tradeIds: tradeIdList };
    const url = this._urlService.getUrl('COLLECT_TVF.tradeReprocess', { payload });

    return this._httpService.post(url, payload).pipe(catchError(throwError));
  }

  errorsReportAsExcel(tradeIdList: string[] | null = null) {
    const payload = { tradeIds: tradeIdList };
    const url = this._urlService.getUrl('COLLECT_TVF.errorsReportExport', { payload });

    return this._httpService
      .post(url, payload, {}, ResponseType.ARRAYBUFFER)
      .pipe(catchError(throwError));
  }

  createError(payload: CreateErrorDTO) {
    const url = this._urlService.getUrl('API_URL_TVF_LOGS.createError');
    return this._httpService.post(url, payload).pipe(catchError((err) => throwError(() => err)));
  }
  updateError(payload: UpdateErrorDTO) {
    const url = this._urlService.getUrl('API_URL_TVF_LOGS.updateError');
    return this._httpService.put(url, payload).pipe(catchError((err) => throwError(() => err)));
  }

  deleteError(idTrade: string) {
    const url = this._urlService.getUrl('API_URL_TVF_LOGS.deleteError');
    return this._httpService
      .delete(url, {
        params: { idTrade },
      })
      .pipe(catchError((err) => throwError(() => err)));
  }

  errorsDlqsReportAsExcel({
    startDate,
    endDate,
    idTrade,
  }: {
    startDate: string;
    endDate: string;
    idTrade: string;
  }) {
    const url = this._urlService.getUrl('COLLECT_TVF.errorsReportExport');

    const payload = {
      idTrade,
      startDate,
      endDate,
    };

    return this._httpService
      .get(url, payload, ResponseType.ARRAYBUFFER)
      .pipe(catchError(throwError));
  }
}
